export default {
  authorization: "authorization",
  cancel: "Cancel",
  delete: "Delete",
  wear: "Wear",
  submit: "Submit",
  create: "Create",
  dashboard: "Dashboard",
  asset: "Asset",
  details: "Details",
  alerts: "Alerts",
  custom: "Custom",
  confirmationOfOrder: "Confirmation of Order",
  feature: "Feature",
  equipment: "Equipment",
  comment: "Comment",
  select: "Select",
  description: "Description",
  administrator: "Administrator",
  digger: "Digger",
  yearOfConstruction: "Year of Construction",
  yearOfProduction: "Year of Production",
  confirm: "Confirm",
  edit: "Edit",
  event: "Event",
  continue: "Continue",
  machine: "Machine",
  media: "Media",
  image: "Image",
  deliveryNote: "Delivery Note",
  tenant: "Tenant",
  noComment: "No comment added",
  scheduler: "Scheduler",
  productArea: "Product Area",
  productDivision: "Product Division",
  productGroup: "Product Group",
  productLine: "Product Line",
  productFamily: "Product Family",
  productModel: "Product Model",
  productCategory: "Product Category",
  wheelLoader: "Wheel Loader",
  invoice: "Invoice",
  crawler: "Crawler",
  quickChanger: "Quick Changer",
  weldingBadge: "Welding Badge",
  save: "Save",
  listOfParts: "List of Parts",
  towerPiece: "Tower Piece",
  next: "Next",
  yes: "Yes",
  no: "No",
  back: "Back",
  assign: "Assign",
  rentalAgreement: "rental agreement",
  topSlewingCranes: "top slewing cranes",
  OK: "OK",
  field: "Field",
  key: "Key",
  value: "Value",
  all: "All",
  user: "User",
  paired: "Paired",
  notPaired: "Not Paired",
  receiver: "Receiver",
  list: "List",
  rest: "Rest",
  interval: "Interval",
  state: "State",
  status: "Status",
  coupling: "Coupling",
  never: "never",
  optional: "Optional",
  good: "Good",
  critical: "Critical",
  unknown: "Unknown",
  manager: "Manager",
  new: "New",
  existingTags: "Existing Tags",
};
